export type TimeTheme = "day" | "night";

export function timeThemeFor(startTime: string): TimeTheme {
  const hour = Number.parseInt(startTime.split(":")[0] ?? "", 10);
  return Number.isFinite(hour) && (hour < 6 || hour >= 18) ? "night" : "day";
}

export function applyTimeTheme(startTime: string): TimeTheme {
  const theme = timeThemeFor(startTime);
  document.documentElement.dataset.timeTheme = theme;
  document.body.dataset.timeTheme = theme;
  document
    .querySelector<HTMLMetaElement>('meta[name="theme-color"]')
    ?.setAttribute("content", theme === "night" ? "#120C1C" : "#F5F3EB");
  return theme;
}
